import { Bar, Cell } from 'recharts';
import { chartColor, type ChartColorKey } from '@/lib/chart-colors';
import {
  hatchPatternId,
  partialBarLabel,
  type PartialLabels,
} from '@/components/ui/charts/chart-partial';

export type MetricsChartBarSeriesProps = {
  dataKey: string;
  name?: string;
  colorKey?: ChartColorKey;
  stackId?: string;
  radius?: number | [number, number, number, number];
  /** Row indexes of the partial buckets: hatched bars (CHART-02). */
  partialIndexes?: readonly number[];
  /**
   * Labels above the first/last partial bar (CHART-03); pass them to one
   * series only (the top one of a stack).
   */
  partialLabels?: PartialLabels;
};

/** Solid bar fill using theme chart colors (no gradient). */
export function MetricsChartBarSeries({
  dataKey,
  name,
  colorKey = 1,
  stackId,
  radius = [2, 2, 0, 0],
  partialIndexes = [],
  partialLabels,
}: MetricsChartBarSeriesProps) {
  const fill = chartColor(colorKey);
  const hatch = `url(#${hatchPatternId(colorKey)})`;
  // Cells only up to the last partial bar; the bars after it keep `fill`.
  const cellCount = partialIndexes.length ? Math.max(...partialIndexes) + 1 : 0;
  return (
    <Bar
      dataKey={dataKey}
      name={name}
      stackId={stackId}
      fill={fill}
      radius={radius}
      label={
        partialLabels && partialIndexes.length
          ? partialBarLabel(partialIndexes, partialLabels)
          : undefined
      }
    >
      {Array.from({ length: cellCount }, (_, index) => (
        <Cell
          key={index}
          fill={partialIndexes.includes(index) ? hatch : fill}
        />
      ))}
    </Bar>
  );
}
